import Bookings from "../components/Bookings";
import Header from "../components/common/Header";
import Hero from "../components/Hero";
import HowItWorks from "../components/HowItWorks";
import ImageSection from "../components/ImageSection";
import KeyFacts from "../components/KeyFacts";
import ServicePlace from "../components/ServicePlace";
import Services from "../components/Services";
import Testimonials from "../components/Testimonials";
import Footer from "../components/common/Footer";


function Home() {
    window.scrollTo(0, 0);

  return (
    <div className='App'>
      <Header/>
      <Hero/>
      <HowItWorks/>
      <ImageSection/>
      <KeyFacts/>
      <ServicePlace/>
      <Testimonials/>
      <Services/>
      <Bookings/>
      <Footer/>
      
    </div>
  );
}

export default Home;
